import React from 'react'
import { ActionList } from '../action'
import { ActionListProps } from '../action/action-list'
import { css, cx } from '@emotion/css'

const rowActionListCss = (isRelatedPopoverOpen?: boolean) => css`
  transition: opacity 0.15s;
  opacity: ${isRelatedPopoverOpen ? 1 : 0};
  pointer-events: none;
`

export const rowActionListHoverCss: string = 'grid-row-action-list'

export function RowActionList({
  children,
  className,
  isRelatedPopoverOpen
}: ActionListProps) {
  return (
    <ActionList
      className={cx(
        rowActionListCss(isRelatedPopoverOpen),
        rowActionListHoverCss,
        className
      )}
      children={children}
    />
  )
}
